import { type FC } from 'react';

import { Link } from '../Link';
import { Text } from '../Typography';
import {
  itemStyles,
  listStyles,
  navigationStyles,
  separatorStyles,
} from './Breadcrumbs.styles';
import { type BreadcrumbsProps } from './Breadcrumbs.types';

const Breadcrumbs: FC<BreadcrumbsProps> = ({
  items,
  ariaLabel = 'Breadcrumb',
  linkAs,
  className,
}) => (
  <nav aria-label={ariaLabel} css={navigationStyles} className={className}>
    <ol css={listStyles}>
      {items.map((item, index) => {
        const isCurrent = index === items.length - 1;

        return (
          <li
            key={`${String(item.label)}:${index}`}
            css={itemStyles}
            aria-current={isCurrent ? 'page' : undefined}
          >
            {item.href && !isCurrent ? (
              <Link as={linkAs} href={item.href} underline="hover">
                {item.label}
              </Link>
            ) : (
              <Text as="span" size="sm">
                {item.label}
              </Text>
            )}
            {!isCurrent && (
              <span css={separatorStyles} aria-hidden="true">
                /
              </span>
            )}
          </li>
        );
      })}
    </ol>
  </nav>
);

Breadcrumbs.displayName = 'Breadcrumbs';

export default Breadcrumbs;
